class ModalBox extends HTMLElement {
  constructor() {
    super();
    window.addEventListener("DOMContentLoaded", () => this.init());
    this.hideListener = (event) => this.hide(event);
    this.shown = false; // Initialize shown property
  }

  init() {
    if (this.dataset.for === undefined) return;

    if (this.dataset.minWidth) {
      this.minWidth = parseInt(this.dataset.minWidth);
    }

    this.triggerElements = document.querySelectorAll(this.dataset.for);
    if (!this.triggerElements.length) return;

    this.overlay = document.getElementById('popupOverlay');
    if (!this.overlay) {
      this.overlay = document.createElement('div');
      this.overlay.id = 'popupOverlay';
      this.overlay.textContent = ' ';
      this.overlay.style.display = 'none';
      this.overlay.classList.add('popupOverlay');
      document.documentElement.appendChild(this.overlay);
      window.addEventListener('load', () => {
        this.overlay.style.minHeight = document.body.scrollHeight + 'px';
      });
    }

    this.triggerElements.forEach(element => {
      element.addEventListener("click", (event) => this.show(event));
      element.classList.add("modal-clickable");
    });

    this.x = this.querySelectorAll('.x, .modal-x');
    this.x.forEach(element => element.addEventListener('click', this.hideListener));

    this.overlay.style.minHeight = '100%';
  }

  show(event) {
    console.log('show')
    if (!this.shown) {
      this.overlay.style.minHeight = document.body.scrollHeight + 'px';
      this.overlay.style.display = 'block';
      this.style.display = 'block';

      let left = event.pageX;
      let top = event.pageY;
      if (this.minWidth) {
        if (document.body.scrollWidth < 750) {
          this.minWidth = Math.min(this.minWidth, 360);
        }
        // dont let it start more to the right than its width
        if (document.body.scrollWidth - left < this.minWidth + 20)
          left = document.body.scrollWidth - this.minWidth - 20;
      }

      if (document.body.scrollWidth < 500) {
        // horizontally center on mobile
        if (this.minWidth) {
          left = 0;
        }

        // make sure it doesnt span the fold when opened
        if (window.innerHeight < top - window.scrollY + this.scrollHeight) {
          top = window.innerHeight - this.scrollHeight - 20 + window.scrollY;
          if (top < window.scrollY + 20) top = window.scrollY + 20;
        }
      }
      this.style.left = left + 'px';
      this.style.top = top + 'px';

      setTimeout(() => {
        this.overlay.classList.add('active');
        this.classList.add('active');
      }, 0);

      this.overlay.addEventListener('click', this.hideListener);
      document.body.classList.add('overflow-hidden');
    }

    this.shown = true; // Set shown to true when modal is shown
  }

  hide(event) {
    console.log('hide')
    event.stopPropagation(); // Stop event propagation here

    this.overlay.removeEventListener('click', this.hideListener);
    this.overlay.classList.remove('active');
    this.classList.remove('active');
    setTimeout(() => {
      this.overlay.style.display = 'none';
      this.style.display = 'none';
    }, 300);
    document.body.classList.remove('overflow-hidden');
    this.shown = false; // Set shown to false when modal is hidden
  }

}

customElements.define('modal-box', ModalBox);
